/**
 * @namespace TeaserClick
 * @aka PIANO.TeaserClick
 *
 */
PIANO.TeaserClick = function (window, document) {

  /**
   *
   * @param {?Element} [currentElement]
   * @return {string}
   */
  function findPlacement(currentElement) {
    if (null === currentElement) {
      return 'Andere';
    }
    var name = currentElement.localName;
    var currentElementClassList = currentElement.classList;
    if ('div' === name && currentElementClassList.contains('image')) {
      return 'Bild';
    }
    if ('h2' === name && currentElementClassList.contains('hgroup')) {
      return 'Überschrift';
    }
    if (('div' === name || 'article' === name) && currentElementClassList.contains('teaser')) {
      return 'Text';
    }
    return findPlacement(currentElement.parentElement);
  }

  /**
   *
   * @param {Element} elementTarget
   */
  var trackTeaserClick = function (elementTarget) {
    if (!PIANO.Utils.isEnabled()) {
      return;
    }

    var elementTeaser = elementTarget.closest('.teaser');
    if (null === elementTeaser) {
      return;
    }

    var elementTracking = elementTeaser.querySelector('script[data-spy=piano]');
    if (null === elementTracking) {
      return;
    }

    try {
      var trackingOptions = JSON.parse(elementTracking.textContent);
    } catch (e) {
      return;
    }

    var teaserPlayer = 'false';
    var teaserMedia = '';
    if (elementTeaser.classList.contains('teaser-mediaplayer')) {
      teaserPlayer = 'true';
      var mediaElement = elementTeaser.querySelector('[data-spy=teaser-mediaplayer]');
      if (null !== mediaElement) {
        if (mediaElement.classList.contains('video')) {
          teaserMedia = 'Video';
        } else if (mediaElement.classList.contains('audio')) {
          teaserMedia = 'Audio';
        }
      }
    }

    var clickData = {
      'onsitead_type': 'Publisher',
      'onsitead_advertiser': trackingOptions.onsitead_advertiser,
      'onsitead_campaign': PIANO.Utils.getPageInformation('contentId'),
      'onsitead_category': '',
      'onsitead_creation': trackingOptions.onsitead_creation,
      'onsitead_detailed_placement': findPlacement(elementTarget),
      'onsitead_format': '',
      'onsitead_url': trackingOptions.onsitead_url,
      'onsitead_variant': '',
      'onsitead_teaser_bar_name': trackingOptions.onsitead_teaser_bar_name,
      'onsitead_teaser_bar_id': '',
      'onsitead_recommender': trackingOptions.onsitead_recommender,
      'onsitead_recommender_model': '',
      'onsitead_teaser_player': teaserPlayer,
      'onsitead_teaser_media': teaserMedia
    };

    PIANO.Queue.push({
      name: 'publisher.click',
      data: clickData
    });
  }

  // Listen to all clicks on the document
  document.addEventListener('click', function (event) {
    if (!PIANO.Utils.isEnabled()) {
      return;
    }

    // If the clicked element doesn't have the class, bail
    if (!event.target.closest('.clickzone')) {
      return void 0;
    }

    // Otherwise, run your code...
    console.debug('Tracking Piano TeaserClick: `.clickzone` click detected', event.target);

    trackTeaserClick(event.target)
  }, false);

  /**
   * --------------------------------------------------------------------------
   * Public Pageview Api
   * --------------------------------------------------------------------------
   */
  return {};

}(window, document);
